import { render, staticRenderFns } from "./CourseSearch.vue?vue&type=template&id=b6132574&scoped=true"
import script from "./CourseSearch.vue?vue&type=script&lang=js"
export * from "./CourseSearch.vue?vue&type=script&lang=js"
import style0 from "./CourseSearch.vue?vue&type=style&index=0&id=b6132574&prod&lang=scss&scoped=true"
import style1 from "./CourseSearch.vue?vue&type=style&index=1&id=b6132574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6132574",
  null
  
)

export default component.exports